import React from 'react';
import { Section } from './ui/Section';
export function Stats() {
  return <Section variant="alt" data-id="element-217">
      <div className="bg-white border-2 border-brand-primary rounded-lg p-6 shadow-card" data-id="element-218">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center" data-id="element-219">
          <div data-id="element-220">
            <div className="font-heading text-2xl md:text-3xl font-bold text-brand-accent" data-id="element-221">
              +8.000
            </div>
            <div className="font-body text-brand-textMuted text-xs" data-id="element-222">
              Psicólogos activos
            </div>
          </div>
          <div data-id="element-223">
            <div className="font-heading text-2xl md:text-3xl font-bold text-brand-accent" data-id="element-224">
              600+
            </div>
            <div className="font-body text-brand-textMuted text-xs" data-id="element-225">
              Consultas lanzadas
            </div>
          </div>
          <div data-id="element-226">
            <div className="font-heading text-2xl md:text-3xl font-bold text-brand-accent" data-id="element-227">
              200K+
            </div>
            <div className="font-body text-brand-textMuted text-xs" data-id="element-228">
              Páginas material
            </div>
          </div>
          <div data-id="element-229">
            <div className="font-heading text-2xl md:text-3xl font-bold text-brand-accent" data-id="element-230">
              5h+
            </div>
            <div className="font-body text-brand-textMuted text-xs" data-id="element-231">
              Ahorradas/semana
            </div>
          </div>
        </div>
      </div>
    </Section>;
}